// extracted by mini-css-extract-plugin
module.exports = {"header":"TimeEntries-module--header--2zNiY","heading":"TimeEntries-module--heading--auqat","sortMembers":"TimeEntries-module--sortMembers--1Vuk6"};